import dayjs from "dayjs";
import * as types from "../types/cashback";

const INITIAL_STATE = {
  cashback_filtro: {
    data_inicial: dayjs().subtract(1, "day").format("YYYY-MM-DD"),
    data_final: dayjs().add(1, "day").format("YYYY-MM-DD"),
    bonus: 0,
    type_transaction: 0,
  },
  cashback_page: 1,
  cashback_perpage: 10,
  cashback_total: 0,
  cashback_lista: [],
  cashback: {},
  loading: false,
};

export default (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case types.SET_CASHBACK:
      return { ...state, cashback: action.payload };
    case types.LOAD_CASHBACKS_LIST:
      return { ...state, cashback_lista: action.payload };
    case types.SET_CASHBACKS_PAGE:
      return { ...state, cashback_page: action.payload };
    case types.SET_CASHBACKS_PERPAGE:
      return { ...state, cashback_perpage: action.payload };
    case types.SET_CASHBACKS_TOTAL:
      return { ...state, cashback_total: action.payload };
    case types.CASHBACKS_LOADING:
      return { ...state, loading: action.payload };
    case types.SET_CASHBACKS_FILTRO:
      return {
        ...state,
        cashback_filtro: { ...state.cashback_filtro, ...action.payload },
      };
    default:
      return state;
  }
};
